<template>
	<div class="hdl-auth">
		<div class="hdl-auth-content">
			<slot />
	 	</div>
	</div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-facing-decorator';

@Component
export default class BaseAuth extends Vue {

}
</script>

<style lang="scss">
@media (max-height: 812px) {
	.hdl-auth {
		@apply items-start;
	}
}

@media (min-height: 812px) {
	.hdl-auth {
		@apply items-center;
	}
}

.hdl-auth {
	@apply flex flex-row h-full w-full justify-center bg-fill;

	.hdl-auth-content {
		width: 460px;
	}
}
</style>
